/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Limits_TitleInputs */

const en_svc_integration_limits_title = /** @type {(inputs: Svc_Integration_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What integration does not mean.`)
};

const lv_svc_integration_limits_title = /** @type {(inputs: Svc_Integration_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko integrācija nenozīmē.`)
};

/**
* | output |
* | --- |
* | "What integration does not mean." |
*
* @param {Svc_Integration_Limits_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_limits_title = /** @type {((inputs?: Svc_Integration_Limits_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Limits_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_limits_title(inputs)
	return en_svc_integration_limits_title(inputs)
});